import { BASE_URL } from "../config";
import { axiosInstance } from "../providers/AxiosProvider";

export function fetchGroup() {
  return axiosInstance.get(`${BASE_URL}/api/groups`);
}
export function fetchNoGroup() {
  return axiosInstance.get(`${BASE_URL}/api/students/no-group`);
}

export function addStudentsToGroup(selectedGroup, students) {
  const body = {
    students: students,
  };
  return axiosInstance.post(
    `${BASE_URL}/api/groups/${selectedGroup}/students`,
    body
  );
}

export function removeStudentsFromGroup(selectedGroup, students) {
  return axiosInstance.delete(
    `${BASE_URL}/api/groups/${selectedGroup}/students`,
    {
      data: {
        students: students,
      },
    }
  );
}

export function createGroup(groupName) {
  const body = {
    name: groupName,
  };
  return axiosInstance.post(
    `${BASE_URL}/api/groups`,

    body
  );
}

export function deleteGroup(groupId) {
  return axiosInstance.delete(`${BASE_URL}/api/groups/${groupId}`);
}
